export { default as Img200 } from './processed/200/background.jpg';
export { default as Img400 } from './processed/400/background.jpg';
export { default as Img600 } from './processed/600/background.jpg';
export { default as Img800 } from './processed/800/background.jpg';
export { default as Img1000 } from './processed/1000/background.jpg';
export { default as Imgthumb } from './processed/thumb/background.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/background.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/background.jpg';
export const ImgData = { width: 1000, height: 1000, ratio: 1, orientation: 'portrait' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      228,
      20,
      21
    ],
    "_population": 2506,
    "_hsl": [
      0.999198717948718,
      0.8387096774193548,
      0.4862745098039216
    ]
  },
  "LightVibrant": {
    "_rgb": [
      251,
      110,
      110
    ],
    "_population": 2215,
    "_hsl": [
      0,
      0.9463087248322147,
      0.7078431372549019
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      122,
      11,
      11
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      118,
      115,
      115
    ],
    "_population": 1677,
    "_hsl": [
      0,
      0.012875536480686709,
      0.45686274509803926
    ]
  },
  "LightMuted": {
    "_rgb": [
      216,
      165,
      166
    ],
    "_population": 1952,
    "_hsl": [
      0.9967320261437909,
      0.39534883720930236,
      0.7470588235294118
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      78,
      78
    ],
    "_population": 2373,
    "_hsl": [
      0,
      0,
      0.3058823529411765
    ]
  }
};



// WEBPACK FOOTER //
// ./src/content/images/background.js